import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import './Categoria.css';

const CategoriaDataTable = () => {
  const [categorias, setCategorias] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [showCategoryDialog, setShowCategoryDialog] = useState(false);
  const [categoryDialogMode, setCategoryDialogMode] = useState('add');
  const [editedCategory, setEditedCategory] = useState({
    tipo: null,
    area: null,
    nivel: 0,
    descripcion: '',
    puntos: 0,
    id_usuario: localStorage.getItem('username') // ID de usuario por defecto
  });
  const [filteredCategorias, setFilteredCategorias] = useState([]);

  const tipoOptions = [
    { id: 1, nombre: 'Positivo nivel 1' },
    { id: 2, nombre: 'Positivo nivel 2' },
    { id: 3, nombre: 'Positivo nivel 3' },
    { id: 4, nombre: 'Preocupante nivel 1' },
    { id: 5, nombre: 'Preocupante nivel 2' },
    { id: 6, nombre: 'Preocupante nivel 3' }
  ];

  const areaOptions = [
    { id: 1, nombre: 'INVENTARIO' },
    { id: 2, nombre: 'VISUAL' },
    { id: 3, nombre: 'IMAGEN PERSONAL' },
    { id: 4, nombre: 'IMAGEN TIENDA' },
    { id: 5, nombre: 'SERVICIO' },
    { id: 6, nombre: 'GENERAL' },
    { id: 7, nombre: 'VENTA Y SERVICIO' }
  ];

  const toast = useRef(null);

  const fetchCategorias = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/categoria/findall', {
        auth: {
          username: 'admin',
          password: 'querty'
        }
      });
      setCategorias(response.data);
    } catch (error) {
      console.error('Error al obtener las categorías:', error);
      showToast('error', 'Error', 'Error al obtener las categorías');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategorias();
  }, [fetchCategorias]);

  useEffect(() => {
    const filteredData = categorias.filter(categoria => {
      const searchString = globalFilterValue.toLowerCase();
      return (
        categoria.tipoCategoria.nombre.toLowerCase().includes(searchString) ||
        categoria.area.nombre.toLowerCase().includes(searchString) ||
        categoria.descripcion.toLowerCase().includes(searchString) ||
        categoria.puntos.toString().includes(searchString)
      );
    });
    setFilteredCategorias(filteredData);
  }, [categorias, globalFilterValue]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="p-d-flex p-jc-between p-mb-3">
        <div className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Buscar en todas las columnas"
          />
        </div>
        <Button
          label="Añadir Categoría"
          icon="pi pi-plus"
          onClick={() => { setShowCategoryDialog(true); setCategoryDialogMode('add'); }}
          className="p-button-success"
        />
      </div>
    );
  };

  const addCategory = async () => {
    if (!validateCategory(editedCategory)) {
      showToast('error', 'Error', 'Por favor, seleccione un tipo y un área válidos');
      return;
    }

    try {
      const categoryToAdd = {
        tipoCategoria: { id: editedCategory.tipo.id },
        area: { id: editedCategory.area.id },
        puntos: editedCategory.puntos,
        descripcion: editedCategory.descripcion,
        id_usuario: editedCategory.id_usuario
      };

      await axios.post('/api/categoria/save', categoryToAdd, {
        auth: {
          username: 'admin',
          password: 'querty'
        }
      });

      showToast('success', 'Categoría añadida', 'La nueva categoría se ha añadido con éxito.');
      fetchCategorias();

      setShowCategoryDialog(false);
      resetEditedCategory();
    } catch (error) {
      console.error('Error al agregar la categoría:', error);
      showToast('error', 'Error', 'Error al agregar la categoría');
    }
  };

  const editCategory = async () => {
    if (!validateCategory(editedCategory)) {
      showToast('error', 'Error', 'Por favor, ingrese todos los datos requeridos.');
      return;
    }

    try {
      const updatedCategory = {
        tipoCategoria: { id: editedCategory.tipo.id },
        area: { id: editedCategory.area.id },
        puntos: editedCategory.puntos,
        descripcion: editedCategory.descripcion,
        id_usuario: editedCategory.id_usuario
      };

      await axios.put(`/api/categoria/updatebyid/${selectedCategory.id}`, updatedCategory, {
        auth: {
          username: 'admin',
          password: 'querty'
        }
      });

      showToast('success', 'Categoría editada', 'La categoría se ha editado con éxito.');
      fetchCategorias();

      setShowCategoryDialog(false);
      resetEditedCategory();
    } catch (error) {
      console.error('Error al editar la categoría:', error);
      showToast('error', 'Error', 'Error al editar la categoría');
    }
  };

  const confirmDeleteCategory = (rowData) => {
    deleteCategory(rowData.id);
  };

  const deleteCategory = async (categoryId) => {
    try {
      await axios.delete(`/api/categoria/deletebyid/${categoryId}`, {
        auth: {
          username: 'admin',
          password: 'querty'
        }
      });
      showToast('success', 'Categoría eliminada', 'La categoría se ha eliminado con éxito.');
      setCategorias(categorias.filter(cat => cat.id !== categoryId));
    } catch (error) {
      console.error('Error al eliminar la categoría:', error);
      showToast('error', 'Error', 'Error al eliminar la categoría');
    }
  };

  const showToast = (severity, summary, detail) => {
    toast.current.show({ severity, summary, detail, life: 3000 });
  };

  const validateCategory = (category) => {
    const { tipo, area, descripcion, puntos } = category;
    return tipo && tipo.id && area && area.id && descripcion && puntos !== null;
  };

  const header = renderHeader();

  const resetEditedCategory = () => {
    setEditedCategory({
      tipo: null,
      area: null,
      descripcion: '',
      puntos: 0,
      id_usuario: localStorage.getItem('username')
    });
  };

  useEffect(() => {
    if (categoryDialogMode === 'edit' && selectedCategory) {
      // Inicializar editedCategory con los valores de la categoría seleccionada en el modo de edición
      setEditedCategory({
        tipo: selectedCategory.tipoCategoria,
        area: selectedCategory.area,
        descripcion: selectedCategory.descripcion,
        puntos: selectedCategory.puntos,
        id_usuario: localStorage.getItem('username')
      });
    } else {
      resetEditedCategory();
    }
  }, [showCategoryDialog, categoryDialogMode, selectedCategory]);

  return (
    <div className="datatable-container">
      <div className="card">
        {header}
        <DataTable
          value={filteredCategorias}
          paginator
          rows={8}
          dataKey="id"
          loading={loading}
          globalFilterFields={['tipoCategoria.nombre', 'area.nombre', 'descripcion']}
          emptyMessage="No se encontraron categorías."
          selectionMode="single"
          selection={selectedCategory}
          onSelectionChange={(e) => setSelectedCategory(e.value)}
        >
          <Column field="tipoCategoria.nombre" header="Tipo" />
          <Column field="area.nombre" header="Área" />
          <Column field="descripcion" header="Descripción" />
          <Column field="puntos" header="Puntos" />
          <Column
            body={(rowData) => (
              <div>
                <Button
                  icon="pi pi-pencil"
                  className="p-button-rounded p-button-success p-mr-2"
                  onClick={() => { setSelectedCategory(rowData); setCategoryDialogMode('edit'); setShowCategoryDialog(true); }}
                />
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  onClick={() => confirmDeleteCategory(rowData)}
                />
              </div>
            )}
          />
        </DataTable>
      </div>
      <Dialog
        visible={showCategoryDialog}
        onHide={() => setShowCategoryDialog(false)}
        header={`${categoryDialogMode === 'add' ? 'Añadir' : 'Editar'} Categoría`}
        className="form-card"
      >
        <div className="p-fluid">
          <div className="p-field">
            <label htmlFor="tipo">Tipo</label>
            <Dropdown
              id="tipo"
              value={editedCategory?.tipo}
              options={tipoOptions}
              onChange={(e) => setEditedCategory({ ...editedCategory, tipo: e.value })}
              optionLabel="nombre"
              placeholder="Seleccionar"
            />
          </div>
          <div className="p-field">
            <label htmlFor="area">Área</label>
            <Dropdown
              id="area"
              value={editedCategory?.area}
              options={areaOptions}
              onChange={(e) => setEditedCategory({ ...editedCategory, area: e.value })}
              optionLabel="nombre"
              placeholder="Seleccionar"
            />
          </div>
          <div className="p-field">
            <label htmlFor="descripcion">Descripción</label>
            <InputText id="descripcion" value={editedCategory?.descripcion} onChange={(e) => setEditedCategory({ ...editedCategory, descripcion: e.target.value })} />
          </div>
          <div className="p-field">
            <label htmlFor="puntos">Puntos</label>
            <InputText id="puntos" value={editedCategory?.puntos} onChange={(e) => setEditedCategory({ ...editedCategory, puntos: e.target.value })} />
          </div>
          <div className="p-field">
            <label htmlFor="id_usuario">ID Usuario</label>
            <InputText
              id="id_usuario"
              value={editedCategory?.id_usuario}
              readOnly={true} // Asegúrate de que sea de solo lectura
            />
          </div>
        </div>
        <div className="p-mt-2">
          <Button label="Cancelar" className="p-button-text" onClick={() => setShowCategoryDialog(false)} />
          <Button label="Guardar" className="p-button-primary p-ml-2" onClick={categoryDialogMode === 'add' ? addCategory : editCategory} />
        </div>
      </Dialog>
      <Toast ref={toast} />
    </div>
  );
};

export default CategoriaDataTable;
